import React, { useContext } from "react";
import { HubContext } from "Redux/Context/context";
import RegisteredActivityList from "./Registered";
import PublishedActivityList from "./Published";
import FavoriteActivityList from "./Favorite";

function ActivityList() {
  const { myActivitiesState } = useContext(HubContext);
  return (
    <>
      {myActivitiesState.module === "REGISTERED" && <RegisteredActivityList />}
      {myActivitiesState.module === "PUBLISHED" && <PublishedActivityList />}
      {myActivitiesState.module === "FAVORITE" && <FavoriteActivityList />}
    </>
  );
}

export default ActivityList;
